var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "page-title-bar mb-7" }, [
        _c("i", { staticClass: "ico ico-system" }),
        _vm._v(_vm._s(_vm.$t("Label Operations")) + " ")
      ]),
      _c(
        "v-tabs",
        {
          staticClass: "custom-tabs",
          attrs: { "background-color": "#001e38", color: "#fff", grow: "" },
          on: { change: _vm.handleTabChange },
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c("v-tab", [_vm._v(" " + _vm._s(_vm.$t("LABEL OPERATION")) + " ")]),
          _c("v-tab", [_vm._v(" " + _vm._s(_vm.$t("LABEL SEARCH")) + " ")])
        ],
        1
      ),
      _vm.activeTab === 0
        ? _c(
            "div",
            { staticClass: "mt-8" },
            [
              _c(
                "v-row",
                { staticClass: "searchArea" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c("v-select", {
                        staticClass: "form-select",
                        attrs: {
                          label: _vm.$t("Request Type") + " *",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          "item-text": "text",
                          "item-value": "value",
                          items: _vm.requestTypeOptions
                        },
                        model: {
                          value: _vm.requestType,
                          callback: function($$v) {
                            _vm.requestType = $$v
                          },
                          expression: "requestType"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex align-center pr-0",
                      attrs: { cols: "2" }
                    },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "close-on-content-click": false,
                            transition: "scale-transition",
                            "offset-y": "",
                            "min-width": "290px"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-text-field",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "form-input",
                                            attrs: {
                                              value: _vm.filter.startDate,
                                              label: "" + _vm.$t("Start Time"),
                                              placeholder:
                                                "" +
                                                _vm.$t("Select Start Date"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                              readonly: "",
                                              clearable: ""
                                            },
                                            on: {
                                              "click:clear": function($event) {
                                                return _vm.clearDate(
                                                  _vm.filter,
                                                  "startDate"
                                                )
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "append",
                                                  fn: function() {
                                                    return [
                                                      _c("img", {
                                                        attrs: {
                                                          width: "16",
                                                          height: "16",
                                                          src: require("@/assets/img/ico-calendar.png")
                                                        }
                                                      })
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          "v-text-field",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2814826233
                          ),
                          model: {
                            value: _vm.showStartDatePicker,
                            callback: function($$v) {
                              _vm.showStartDatePicker = $$v
                            },
                            expression: "showStartDatePicker"
                          }
                        },
                        [
                          _c("v-date-picker", {
                            attrs: {
                              locale:
                                _vm.languageCodes[
                                  _vm.$store.getters[
                                    "dataStore/GET_CURRENT_LANGUAGE"
                                  ]
                                ],
                              "no-title": ""
                            },
                            on: {
                              change: _vm.checkStartDate,
                              input: function($event) {
                                _vm.showStartDatePicker = false
                              }
                            },
                            model: {
                              value: _vm.filter.startDate,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "startDate", $$v)
                              },
                              expression: "filter.startDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c("span", { staticClass: "ml-4 mt-5" }, [_vm._v("~")])
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "close-on-content-click": false,
                            transition: "scale-transition",
                            "offset-y": "",
                            "min-width": "290px"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-text-field",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "form-input",
                                            attrs: {
                                              value: _vm.filter.endDate,
                                              label: "" + _vm.$t("End Time"),
                                              placeholder:
                                                "" + _vm.$t("Select End Date"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                              readonly: "",
                                              clearable: ""
                                            },
                                            on: {
                                              "click:clear": function($event) {
                                                return _vm.clearDate(
                                                  _vm.filter,
                                                  "endDate"
                                                )
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "append",
                                                  fn: function() {
                                                    return [
                                                      _c("img", {
                                                        attrs: {
                                                          width: "16",
                                                          height: "16",
                                                          src: require("@/assets/img/ico-calendar.png")
                                                        }
                                                      })
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          "v-text-field",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1796429945
                          ),
                          model: {
                            value: _vm.showEndDatePicker,
                            callback: function($$v) {
                              _vm.showEndDatePicker = $$v
                            },
                            expression: "showEndDatePicker"
                          }
                        },
                        [
                          _c("v-date-picker", {
                            attrs: {
                              locale:
                                _vm.languageCodes[
                                  _vm.$store.getters[
                                    "dataStore/GET_CURRENT_LANGUAGE"
                                  ]
                                ],
                              "no-title": ""
                            },
                            on: {
                              change: _vm.checkEndDate,
                              input: function($event) {
                                _vm.showEndDatePicker = false
                              }
                            },
                            model: {
                              value: _vm.filter.endDate,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "endDate", $$v)
                              },
                              expression: "filter.endDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "d-flex align-end", attrs: { cols: "6" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn type-search mr-3 mb-1",
                          on: {
                            click: function($event) {
                              return _vm.search()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Search")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn type-search mb-1",
                          on: {
                            click: function($event) {
                              return _vm.clear()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Clear")) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-data-table", {
                staticClass: "tbl-type01 mt-10",
                attrs: {
                  "item-key": "id",
                  headers: _vm.headers,
                  items: _vm.tableItems,
                  "hide-default-footer": ""
                }
              }),
              _c(
                "div",
                {
                  staticClass: "d-flex justify-space-between align-center mt-6"
                },
                [
                  _c(
                    "v-dialog",
                    {
                      attrs: { width: "650", persistent: "", scrollable: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "btn ml-2",
                                        attrs: {
                                          text: "",
                                          disabled: _vm.btnDisabled
                                        }
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [_vm._v(_vm._s(_vm.$t("File Upload")))]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        915363093
                      ),
                      model: {
                        value: _vm.fileUploadVisible,
                        callback: function($$v) {
                          _vm.fileUploadVisible = $$v
                        },
                        expression: "fileUploadVisible"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        { staticClass: "popup add_store_popup" },
                        [
                          _c("v-card-title", [
                            _c("h3", { staticClass: "page-title-bar" }, [
                              _c("i", { staticClass: "ico ico-product" }),
                              _vm._v(_vm._s(_vm.$t("File Upload")) + " ")
                            ])
                          ]),
                          _c("v-card-text", [
                            _c("div", [
                              _c("p", { staticClass: "label-txt mb-3" }, [
                                _vm._v(" Request Type "),
                                _c("span", { staticClass: "redbold" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _c("div", { staticClass: "radio-group" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "radio-button",
                                    class: {
                                      active: _vm.requestTypePopup === "ASSIGN"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.requestTypePopup,
                                          expression: "requestTypePopup"
                                        }
                                      ],
                                      attrs: { type: "radio", value: "ASSIGN" },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.requestTypePopup,
                                          "ASSIGN"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.requestTypePopup = "ASSIGN"
                                        }
                                      }
                                    }),
                                    _c("div", { staticClass: "icon-img" }, [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/icons/Assign.svg"),
                                          alt: ""
                                        }
                                      })
                                    ]),
                                    _c("div", { staticClass: "text-img" }, [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("Assign")) + " "
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "radio-button",
                                    class: {
                                      active:
                                        _vm.requestTypePopup === "UNASSIGN"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.requestTypePopup,
                                          expression: "requestTypePopup"
                                        }
                                      ],
                                      attrs: {
                                        type: "radio",
                                        value: "UNASSIGN"
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.requestTypePopup,
                                          "UNASSIGN"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.requestTypePopup = "UNASSIGN"
                                        }
                                      }
                                    }),
                                    _c("div", { staticClass: "icon-img" }, [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/icons/Unassign.svg"),
                                          alt: ""
                                        }
                                      })
                                    ]),
                                    _c("div", { staticClass: "text-img" }, [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("Unassign")) + " "
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "radio-button",
                                    class: {
                                      active: _vm.requestTypePopup === "MAPPING"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.requestTypePopup,
                                          expression: "requestTypePopup"
                                        }
                                      ],
                                      attrs: {
                                        type: "radio",
                                        value: "MAPPING"
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.requestTypePopup,
                                          "MAPPING"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.requestTypePopup = "MAPPING"
                                        }
                                      }
                                    }),
                                    _c("div", { staticClass: "icon-img" }, [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/icons/Mapping.svg"),
                                          alt: ""
                                        }
                                      })
                                    ]),
                                    _c("div", { staticClass: "text-img" }, [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("Mapping")) + " "
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "radio-button",
                                    class: {
                                      active:
                                        _vm.requestTypePopup === "ADD_INFO"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.requestTypePopup,
                                          expression: "requestTypePopup"
                                        }
                                      ],
                                      attrs: {
                                        type: "radio",
                                        value: "ADD_INFO"
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.requestTypePopup,
                                          "ADD_INFO"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.requestTypePopup = "ADD_INFO"
                                        }
                                      }
                                    }),
                                    _c("div", { staticClass: "icon-img" }, [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/icons/ad_info.svg"),
                                          alt: ""
                                        }
                                      })
                                    ]),
                                    _c("div", { staticClass: "text-img" }, [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("Add_Info")) + " "
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "radio-button",
                                    class: {
                                      active: _vm.requestTypePopup === "DELETE"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.requestTypePopup,
                                          expression: "requestTypePopup"
                                        }
                                      ],
                                      attrs: { type: "radio", value: "DELETE" },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.requestTypePopup,
                                          "DELETE"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.requestTypePopup = "DELETE"
                                        }
                                      }
                                    }),
                                    _c("div", { staticClass: "icon-img" }, [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/icons/Delete.svg"),
                                          alt: ""
                                        }
                                      })
                                    ]),
                                    _c("div", { staticClass: "text-img" }, [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("Delete")) + " "
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ]),
                            _c(
                              "div",
                              { staticClass: "mt-8" },
                              [
                                _c(
                                  "p",
                                  { staticClass: "label-txt mb-2" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("Browse File (Extension:")
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.requestTypePopup === "ASSIGN"
                                            ? ".link"
                                            : _vm.requestTypePopup ===
                                              "UNASSIGN"
                                            ? ".unlink"
                                            : _vm.requestTypePopup === "MAPPING"
                                            ? ".map"
                                            : _vm.requestTypePopup ===
                                              "ADD_INFO"
                                            ? ".elink"
                                            : ".del"
                                        ) +
                                        ") "
                                    ),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          right: "",
                                          "content-class": "tooltip"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "span",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "view-format"
                                                        },
                                                        "span",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "View File Format"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "redbold"
                                                        },
                                                        [_vm._v("*")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3841729985
                                        )
                                      },
                                      [
                                        _vm.requestTypePopup === "ASSIGN"
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/assign.png"),
                                                height: "200",
                                                width: "500"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm.requestTypePopup === "UNASSIGN"
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/Unassign.png"),
                                                height: "200",
                                                width: "500"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm.requestTypePopup === "MAPPING"
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/mapping.png"),
                                                height: "200",
                                                width: "500"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm.requestTypePopup === "ADD_INFO"
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/add_info.png"),
                                                height: "200",
                                                width: "500"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm.requestTypePopup === "DELETE"
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/delete.png"),
                                                height: "200",
                                                width: "500"
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c("v-file-input", {
                                  staticClass: "form-file",
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "",
                                    placeholder: _vm.$t("Select File"),
                                    "prepend-icon": "",
                                    "append-icon": "mdi-file-upload",
                                    accept: _vm.acceptedFileExtension
                                  },
                                  model: {
                                    value: _vm.selectedFile,
                                    callback: function($$v) {
                                      _vm.selectedFile = $$v
                                    },
                                    expression: "selectedFile"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("div", { staticClass: "mt-4" }, [
                              _c("p", { staticClass: "label-txt" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("Selected Files")) + " "
                                )
                              ]),
                              _c(
                                "div",
                                { staticClass: "selected-file-box mt-2" },
                                [
                                  _vm.selectedFile
                                    ? _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.selectedFile.name) +
                                            " "
                                        )
                                      ])
                                    : _c("div", [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "font-size": "var(--font14)"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("No files selected")
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                ]
                              )
                            ])
                          ]),
                          _c(
                            "v-card-actions",
                            { staticClass: "d-flex justify-center" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn",
                                  attrs: { text: "", icon: "" },
                                  on: { click: _vm.uploadFile }
                                },
                                [_vm._v(_vm._s(_vm.$t("Upload")))]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn",
                                  attrs: { text: "", icon: "" },
                                  on: { click: _vm.cancelFileUpload }
                                },
                                [_vm._v(_vm._s(_vm.$t("Cancel")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("Pagination", {
                        attrs: {
                          pageInfoText: _vm.pageInfoText,
                          pageIndex: _vm.pageIndex,
                          rowPerPage: _vm.rowPerPage,
                          goToPageInput: _vm.goToPageInput,
                          totalPages: _vm.totalPages
                        },
                        on: {
                          paging: function($event) {
                            return _vm.paging($event)
                          },
                          updatePage: function($event) {
                            return _vm.updatePage($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.activeTab === 1
        ? _c(
            "div",
            { staticClass: "mt-8" },
            [
              _c(
                "div",
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "align-center",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex align-center",
                          attrs: { cols: "3" }
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "form-input mandatory upper-case",
                            attrs: {
                              label: _vm.$t("Label Code") + "*",
                              placeholder: "" + _vm.$t("Input The Label Code"),
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              clearable: ""
                            },
                            model: {
                              value: _vm.labelCode,
                              callback: function($$v) {
                                _vm.labelCode = $$v
                              },
                              expression: "labelCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex align-center mt-6",
                          attrs: { cols: "6" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn type-search mr-3",
                              staticStyle: { width: "170px !important" },
                              attrs: {
                                text: "",
                                disabled: !_vm.labelCode || _vm.btnDisabled
                              },
                              on: { click: _vm.getLabelsTypeInfo }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Search")) + " ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn type-search",
                              staticStyle: { width: "170px !important" },
                              attrs: { text: "" },
                              on: { click: _vm.clearSearch }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Clear")) + " ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-dialog",
                {
                  attrs: { width: "700", persistent: "" },
                  on: {
                    "click:outside": function($event) {
                      _vm.labelDetailsPopup = false
                    }
                  },
                  model: {
                    value: _vm.labelDetailsPopup,
                    callback: function($$v) {
                      _vm.labelDetailsPopup = $$v
                    },
                    expression: "labelDetailsPopup"
                  }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "popup add_store_popup" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "cornerClose",
                          attrs: { icon: "", dark: "", "x-small": "" },
                          on: {
                            click: function($event) {
                              _vm.labelDetailsPopup = false
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("mdi-close")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "popup-titbox align-items-center" },
                        [
                          _c("h3", { staticClass: "page-title-bar" }, [
                            _c("i", { staticClass: "ico ico-template" }),
                            _vm._v(
                              " " + _vm._s(_vm.$t("Label Properties")) + " "
                            )
                          ]),
                          _c("div", { staticClass: "spacer" })
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "v-data-table tbl-type01 mt-6 theme--light"
                        },
                        [
                          _c("div", { staticClass: "v-data-table__wrapper" }, [
                            _c(
                              "table",
                              { staticClass: "table" },
                              _vm._l(_vm.labelDetails, function(value, name) {
                                return _c("tr", { key: name }, [
                                  _c("td", { attrs: { width: "30%" } }, [
                                    _c("strong", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f(
                                              "removeSpacefromCapitalLetter"
                                            )(
                                              _vm._f("camelCaseToProperCase")(
                                                name
                                              )
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  ]),
                                  _c("td", [_vm._v(_vm._s(value))])
                                ])
                              }),
                              0
                            )
                          ])
                        ]
                      ),
                      _c(
                        "v-card-actions",
                        { staticClass: "d-flex justify-center" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn",
                              attrs: { text: "", icon: "" },
                              on: {
                                click: function($event) {
                                  _vm.labelDetailsPopup = false
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Close")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }